// 首页
<template>
  <div class="admin">
    <div class="submit"><el-button type="primary"  @click="submitForm">保存</el-button><span class="tip">操作后务必保存，以免数据丢失</span></div>
    <el-form :model="jsonData" ref="jsonData" label-width="80px">
      <div v-show="$parent.subMenuId===1" name="生产安全">
        <el-tabs v-model="tabActive">
          <el-tab-pane :label="item.name" :name="index+''" v-for="(item,index) in jsonData.scaq" :key="index">
            <el-row :gutter="10">
              <el-card class="box-card">
                <el-form-item label="流程图标" label-width="100px">
                  <mzfile v-model="item.icon" tip="只能上传png背景透明文件，建议尺寸为200px*200px"></mzfile>
                </el-form-item>
                <el-form-item label="左侧介绍类型" label-width="100px">
                  <el-select v-model="item.type">
                    <el-option value="video" label="视频"></el-option>
                    <el-option value="image" label="图片"></el-option>
                    <el-option value="text" label="文字"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="视频" label-width="100px" v-if="item.type==='video'">
                  <video v-if="item.info" :src="item.info" controls class="video">
                    Your browser does not support the video tag.
                  </video>
                  <mzfile2 v-model="item.info" name="上传视频" type="video"></mzfile2>
                </el-form-item>
                <el-form-item label="图片" label-width="100px" v-if="item.type==='image'">
                  <mzfile v-model="item.info" tip="只能上传jpg/jpeg/png文件"></mzfile>
                </el-form-item>
                <el-form-item label="文字" label-width="100px" v-if="item.type==='text'">
                  <MzInput v-model.trim="item.info" type="textarea" :rows="6" placeholder="请输入"></MzInput>
                </el-form-item>
              </el-card>
              <el-card class="box-card">
                <div slot="header">运行数据</div>
                <el-row :gutter="10">
                  <el-col :span="['设备开关','运行情况'].includes(it.name)?5:4" v-for="(it,i) in item.yx" :key="'yx'+i">
                    <el-form-item :label="it.name" :label-width="['设备开关','运行情况'].includes(it.name)?'100px':'150px'">
                      <div v-if="['设备开','设备关'].includes(it.value)">
                        <el-radio-group v-model="it.value">
                          <el-radio label="设备开">设备开</el-radio>
                          <el-radio label="设备关">设备关</el-radio>
                        </el-radio-group>
                      </div>
                      <div v-else-if="['运行正常','运行故障'].includes(it.value)">
                        <el-radio-group v-model="it.value">
                          <el-radio label="运行正常">运行正常</el-radio>
                          <el-radio label="运行故障">运行故障</el-radio>
                        </el-radio-group>
                      </div>
                      <MzInput v-else v-model.trim="it.value" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===2" name="机器狗巡检">
        <el-row :gutter="10" v-if="jsonData.jqg">
          <el-col :span="2" class="label">
            <p>巡检视频</p>
            <el-button type="primary" size="small" @click="updateData('jqg','add')">添加</el-button>
          </el-col>
          <el-col :span="22">
              <el-col :span="8" v-for="(item,index) in jsonData.jqg" :key="index">
                <el-card class="box-card">
                  <span class="del" @click="updateData('jqg','del',index)"><i class="el-icon-circle-close"></i></span>
                  <el-form-item label="名称" label-width="60px">
                    <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                  </el-form-item>
                  <el-form-item label="路线图" label-width="60px">
                    <mzfile v-model="item.imageUrl" tip="只能上传jpg/jpeg/png文件，图片比例5:2.8"></mzfile>
                  </el-form-item>
                  <el-form-item label="视频" label-width="60px">
                    <video :src="item.videoUrl" controls class="video">
                      Your browser does not support the video tag.
                    </video>
                    <mzfile2 v-model="item.videoUrl" name="上传视频" type="video"></mzfile2>
                  </el-form-item>
                </el-card>
              </el-col>
          </el-col>
        </el-row>
      </div>
      <div v-show="$parent.subMenuId===3" name="工艺流程">
        <el-row :gutter="10" v-if="jsonData.gylc">
          <el-col :span="8" v-for="(item,index) in jsonData.gylc" :key="index">
            <el-card class="box-card" style="height:370px">
              <el-form-item label="名称" label-width="100px">
                <span>{{item.name}}</span>
              </el-form-item>
              <el-form-item label="流程介绍类型" label-width="100px">
                <el-select v-model="item.type">
                  <el-option value="video" label="视频"></el-option>
                  <el-option value="image" label="图片"></el-option>
                  <el-option value="text" label="文字"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="视频" label-width="100px" v-if="item.type==='video'">
                <video v-if="item.info" :src="item.info" controls class="video">
                  Your browser does not support the video tag.
                </video>
                <mzfile2 v-model="item.info" name="上传视频" type="video"></mzfile2>
              </el-form-item>
              <el-form-item label="图片" label-width="100px" v-if="item.type==='image'">
                <mzfile v-model="item.info" tip="只能上传jpg/jpeg/png文件"></mzfile>
              </el-form-item>
              <el-form-item label="文字" label-width="100px" v-if="item.type==='text'">
                <MzInput v-model.trim="item.info" type="textarea" :rows="6" placeholder="请输入"></MzInput>
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div v-show="$parent.subMenuId===4" name="生产数字日志">
        <el-row :gutter="10" v-if="jsonData.jqg">
          <el-col :span="2" class="label">
            <p>生产数字日志</p>
            <el-button type="primary" size="small" @click="updateData('jsln','add')">添加</el-button>
          </el-col>
          <el-col :span="22">
              <el-col :span="8" v-for="(item,index) in jsonData.jsln" :key="index">
                <el-card class="box-card">
                  <span class="del" @click="updateData('jsln','del',index)"><i class="el-icon-circle-close"></i></span>
                  <el-form-item label="图片" label-width="60px">
                    <mzfile v-model="item.url" tip="只能上传jpg/jpeg/png文件"></mzfile>
                  </el-form-item>
                </el-card>
              </el-col>
          </el-col>
        </el-row>
      </div>
       <div v-show="$parent.subMenuId===5" name="VR链接">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="VR链接" label-width="100px">
              <MzInput v-model.trim="jsonData.vrUrl" placeholder="请输入"></MzInput>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-show="$parent.subMenuId===6" name="岗位员工">
        <el-tabs v-model="tabActive">
          <el-tab-pane label="视频" name="first">
            <el-row :gutter="10" v-if="jsonData.gwyg">
                <el-col :span="24" v-for="(item,index) in jsonData.gwyg.video" :key="index">
                    <el-form-item :label="'视频链接'+(index+1)" label-width="100px">
                      <MzInput v-model.trim="item.url" placeholder="格式为mp4"></MzInput>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="员工信息" name="second">
            <el-row :gutter="10" v-if="jsonData.gwyg">
              <el-col :span="2" class="label">
                <p>员工信息</p>
                <el-button type="primary" size="small" @click="updateData('gwyg','add')">添加</el-button>
              </el-col>
              <el-col :span="22">
                <el-col :span="8" v-for="(item,index) in jsonData.gwyg.users" :key="index">
                  <el-card class="box-card">
                    <span class="del" @click="updateData('gwyg','del',index)"><i class="el-icon-circle-close"></i></span>
                    <el-form-item label="在岗情况" label-width="80px">
                      <MzInput v-model.trim="item.status" placeholder="请输入"></MzInput>
                    </el-form-item>
                    <el-form-item label="照片" label-width="80px">
                      <mzfile v-model="item.photo" tip="只能上传jpg/jpeg/png文件，比例5:6"></mzfile>
                    </el-form-item>
                    <el-form-item label="介绍" label-width="80px">
                      <MzInput v-model.trim="item.info" type="textarea" :rows="6" placeholder="请输入"></MzInput>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-show="$parent.subMenuId===7" name="集团介绍">
        <el-row :gutter="10">
          <el-col :span="2" class="label">
            <p>集团</p>
            <el-button type="primary" size="small" @click="updateData('jtjs','add')">添加</el-button>
          </el-col>
          <el-col :span="22">
              <el-col :span="24" v-for="(item,index) in jsonData.jtjs" :key="index">
                <el-card class="box-card">
                  <span class="del" @click="updateData('jtjs','del',index)" style="left:0"><i class="el-icon-circle-close"></i></span>
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-form-item label="集团名称" label-width="70px">
                        <MzInput v-model.trim="item.name" placeholder="请输入"></MzInput>
                      </el-form-item>
                    </el-col>
                    <el-col :span="18">
                      <el-form-item label="集团介绍" label-width="100px">
                        <MzInput v-model.trim="item.intro" type="textarea" :rows="4" placeholder="请输入"></MzInput>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="总经理" label-width="70px">
                        <MzInput v-model.trim="item.leader" placeholder="请输入"></MzInput>
                      </el-form-item>
                    </el-col>
                    <el-col :span="18">
                      <el-form-item label="总经理介绍" label-width="100px">
                        <MzInput v-model.trim="item.leaderIntro" type="textarea" :rows="4" placeholder="请输入"></MzInput>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>

import axios from "axios"
import mzfile from '@/components/mz_upload/index';
import mzfile2 from '@/components/mz_upload/fileUpload';
export default {
  components: {mzfile,mzfile2},
  name: '',
  data() {
    return {
      activeNames: [],
      tabActive: '0',
      fileHandle: null,
      jsonData: {jqg: '',gylc:'',jsln:'',vrUrl:'',scaq:'',gwyg:'',jtjs:''},
    };
  },
  created() {
    // this.jsonData = {
    //   jqg: [{name:'巡检视频1',imageUrl:'/assets/image/jqg/xunjian1.png',videoUrl:'/assets/image/jqg/巡检视频1.MP4'},{name:'巡检视频2',imageUrl:'/assets/image/jqg/xunjian2.png',videoUrl:'/assets/image/jqg/巡检视频2.MP4'},{name:'巡检视频3',imageUrl:'/assets/image/jqg/xunjian3.png',videoUrl:'/assets/image/jqg/巡检视频3.MP4'},{name:'巡检视频4',imageUrl:'',videoUrl:'/assets/image/jqg/巡检视频4.MP4'}],
    //   gylc:[{
    //             name:'收集牦牛奶渣',
    //             type: 'text',
    //             info: ''
    //         },{
    //             name: '牦牛奶渣',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name: '废弃处理',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name: '预处理',
    //             type: 'video',
    //             info: ''
    //         },{
    //             name: '巴氏杀菌',
    //             type: 'video',
    //             info: '/assets/image/gylc/巴氏杀菌.mp4'
    //         },{
    //             name:'净乳脱脂',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'凝乳形成',
    //             type: 'video',
    //             info: ''
    //         },{
    //             name:'切割凝块',
    //             type: 'text',
    //             info: ''
    //         },{
    //             name:'乳清分离',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'酪蛋白清洗',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'脱水',
    //             type: 'text',
    //             info: ''
    //         },{
    //             name:'半成品检验',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'不合格返工返料',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'干燥',
    //             type: 'text',
    //             info: ''
    //         },{
    //             name:'研磨',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'包装',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'成品检验',
    //             type: 'text',
    //             info: ''
    //         },{
    //             name:'返厂或废弃处理',
    //             type: 'image',
    //             info: ''
    //         },{
    //             name:'存储',
    //             type: 'image',
    //             info: ''
    //         }],
    //   jsln: [{url:'/assets/image/jsln.png'}],
    //   vrUrl: 'https://realsee.cn/4E9n1nQK?source=wechat_session',
    //   scaq: [{
    //             name: '原料粉碎',
    //             type: 'image',
    //             info: '/assets/image/scaq/原料粉碎.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             },{
    //               icon: 'icon_zs',
    //               name: '转速（r/min）',
    //               value: '55'
    //             },{
    //               icon: 'icon_sc',
    //               name: '加工效率（L/min）',
    //               value: '55'
    //             }],
    //         },{
    //             name: '反应釜',
    //             type: 'image',
    //             info: '/assets/image/scaq/反应釜.jpg',
    //             yx: [{
    //               icon: 'icon_off',
    //               name: '设备开关',
    //               value: '设备关'
    //             },{
    //               icon: 'icon_red',
    //               name: '运行情况',
    //               value: '运行故障'
    //             },{
    //               icon: 'icon_zs',
    //               name: '转速（r/min）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_ph',
    //               name: 'PH值',
    //               value: '7'
    //             }],
    //         },{
    //             name: '净乳机',
    //             type: 'image',
    //             info: '/assets/image/scaq/净乳.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_red',
    //               name: '运行情况',
    //               value: '运行故障'
    //             },{
    //               icon: 'icon_zs',
    //               name: '转速（r/min）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_ph',
    //               name: 'PH值',
    //               value: '7'
    //             }],
    //         },{
    //             name: '脱脂机',
    //             type: 'image',
    //             info: '/assets/image/scaq/脱脂.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             },{
    //               icon: 'icon_zs',
    //               name: '转速（r/min）',
    //               value: '55'
    //             },{
    //               icon: 'icon_sc',
    //               name: '加工效率（L/min）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_ph',
    //               name: 'PH值',
    //               value: '7'
    //             }],
    //         },{
    //             name: '灭菌机',
    //             type: 'image',
    //             info: '/assets/image/scaq/灭菌机.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             },{
    //               icon: 'icon_wd',
    //               name: '蒸汽温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_yq',
    //               name: '蒸气压强（Pa）',
    //               value: '55'
    //             }],
    //         },{
    //             name: '凝乳罐',
    //             type: 'image',
    //             info: '/assets/image/scaq/凝乳罐.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             },{
    //               icon: 'icon_zs',
    //               name: '转速（r/min）',
    //               value: '55'
    //             },{
    //               icon: 'icon_wd',
    //               name: '温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_ph',
    //               name: 'PH值',
    //               value: '7'
    //             }],
    //         },{
    //             name: '破碎机',
    //             type: 'image',
    //             info: '/assets/image/scaq/破碎机.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             },{
    //               icon: 'icon_kl',
    //               name: '颗粒状',
    //               value: '55'
    //             }],
    //         },{
    //             name: '干燥塔',
    //             type: 'image',
    //             info: '/assets/image/scaq/干燥塔.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             },{
    //               icon: 'icon_wd',
    //               name: '蒸汽温度（℃）',
    //               value: '55'
    //             },{
    //               icon: 'icon_yq',
    //               name: '蒸气压强（Pa）',
    //               value: '55'
    //             }],
    //         },{
    //             name: '分目机',
    //             type: 'image',
    //             info: '/assets/image/scaq/分目机.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             },{
    //               icon: 'icon_kl',
    //               name: '颗粒状（30目指示灯）',
    //               value: '55'
    //             },{
    //               icon: 'icon_kl',
    //               name: '颗粒状（60目指示灯）',
    //               value: '55'
    //             },{
    //               icon: 'icon_kl',
    //               name: '颗粒状（90目指示灯）',
    //               value: '55'
    //             }],
    //         },{
    //             name: '自动包装机',
    //             type: 'image',
    //             info: '/assets/image/scaq/自动包装机.jpg',
    //             yx: [{
    //               icon: 'icon_on',
    //               name: '设备开关',
    //               value: '设备开'
    //             },{
    //               icon: 'icon_green',
    //               name: '运行情况',
    //               value: '运行正常'
    //             }]
    //         }],
    //   gwyg:{
    //       video: [{url:''},{url:''},{url:''},{url:''}],
    //       users: [{
    //         status: '在岗',
    //         photo: '/assets/image/zj/3.png',
    //         info: '教授、硕士生导师，西南民族大学校级学术委员会专家。\n研究方向：青藏高原特色民族食品资源的开发、应用的研究，高原天然产物与功能性食品开发，高原微生物资源开发与利用\n主要成果：先后主持参与国家国家级课题 5 项，省部级课题 4 项；获得四川省科技进步二等奖；以第一作者和通讯作者发表核心及SCI论文 58 篇；主编教材 2 部，参编教材 4 部。'
    //       },{
    //         status: '在岗',
    //         photo: '/assets/image/zj/4.png',
    //         info: '西南民族大学食品科学与技术学院院长、教授、博士生导师。\n研究方向：2002年博士毕业于美国Arkansas大学食品科学系，一直从事蛋白质食品方面理论和应用研究。 \n主要成果：主持参加国家级和省部级科研项目20余项，获得授权国家发明专利10件、省级成果6项、省部级科技进步二等奖奖3项、三等奖1项，中国奶业协会和国际奶业联盟科学技术发明一等奖1项，发表论文160余篇，国际学术会议交流论文10余篇，主编著作5部。'
    //       },{
    //         status: '在岗',
    //         photo: '/assets/image/zj/5.png',
    //         info: '西南民族大学食品科学与技术学院院长、教授、博士生导师。\n研究方向：2002年博士毕业于美国Arkansas大学食品科学系，一直从事蛋白质食品方面理论和应用研究。 \n主要成果：主持参加国家级和省部级科研项目20余项，获得授权国家发明专利10件、省级成果6项、省部级科技进步二等奖奖3项、三等奖1项，中国奶业协会和国际奶业联盟科学技术发明一等奖1项，发表论文160余篇，国际学术会议交流论文10余篇，主编著作5部。'
    //       },{
    //         status: '未在岗',
    //         photo: '/assets/image/zj/1.png',
    //         info: '西南民族大学食品科学与技术学院院长、教授、博士生导师。\n研究方向：2002年博士毕业于美国Arkansas大学食品科学系，一直从事蛋白质食品方面理论和应用研究。 \n主要成果：主持参加国家级和省部级科研项目20余项，获得授权国家发明专利10件、省级成果6项、省部级科技进步二等奖奖3项、三等奖1项，中国奶业协会和国际奶业联盟科学技术发明一等奖1项，发表论文160余篇，国际学术会议交流论文10余篇，主编著作5部。'
    //       },{
    //         status: '在岗',
    //         photo: '/assets/image/zj/2.png',
    //         info: '西南民族大学食品科学与技术学院院长、教授、博士生导师。\n研究方向：2002年博士毕业于美国Arkansas大学食品科学系，一直从事蛋白质食品方面理论和应用研究。 \n主要成果：主持参加国家级和省部级科研项目20余项，获得授权国家发明专利10件、省级成果6项、省部级科技进步二等奖奖3项、三等奖1项，中国奶业协会和国际奶业联盟科学技术发明一等奖1项，发表论文160余篇，国际学术会议交流论文10余篇，主编著作5部。'
    //       }]
    //     },
    //   jtjs: [{
    //     name:'成都嘉润置业集团',intro:'成立时间：1995 年 3 月 31 日，总部位于成都市金牛区。\n企业性质：以成都嘉润置业有限责任公司为核心的股份制民营企业，陈先德为控股股东（持股 51%）、实际控制人，注册资本 2000 万元，企业处于存续状态。\n核心业务：以商业地产开发运营为核心，业务覆盖大型市场经营管理、物业管理、建筑装饰，还涉足餐饮文化、农牧科技、文化传播、驾驶培训、出租车营运等第三产业领域。旗下有大成市场、嘉润国际中心等项目，在荷花池商圈开发运营方面有显著成果。',
    //     leader:'陈先德',leaderIntro:'核心职务：成都嘉润置业有限责任公司董事长兼总经理，同时担任中国个体劳动者协会副会长、四川省个体私营经济协会副会长等社会职务。\n持股情况：直接持股 51%，是公司的实际控制人、法定代表人，关联企业 20 余家，在嘉润圣德投资管理、大成市场经营管理等公司担任要职。\n行业影响：长期深耕商业地产与市场运营，推动荷花池 “池上锦” 汉服特色街区等项目发展，积极参与传统服饰文化推广与产业融合，在行业内有一定的知名度与影响力。'
    //   }]
    // }
    this.getData('modelIndex')
  },
  watch:{
    '$parent.subMenuId':{
      handler(val){
        if([1].includes(val)){
          this.tabActive = '0'
        }else{
          this.tabActive = 'first'
        }
        
      }
    }
  },
  methods: {
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          this.jsonData = res.data.data
        }
      })
    },
    saveData(name){
      let params = {
        fileName: name,
        fileData: this.jsonData
      }
      axios.post(this.$baseUrl+'/api/web/file/data/save',params).then(res => {
        if(res.data.code === 200){
          this.$message({
            message: res.data.msg,
            type: 'success',
            customClass: 'adminMsg'
          });
          this.getData('modelIndex')
        }else{
          this.$message({
            message: res.data.msg,
            type: 'error',
            customClass: 'adminMsg'
          });
        }
      })
    },
    updateData(type,btn,index){
      if(btn==='add'){
        if(type==='jqg'){
          this.jsonData.jqg.push({name:'',imageUrl:'',videoUrl:''})
        }else if(type==='jsln'){
          this.jsonData.jsln.push({url:''})
        }else if(type==='gwyg'){
          this.jsonData.gwyg.users.push({photo:'',status:'',intro:''})
        }else if(type==='jtjs'){
          this.jsonData.jtjs.push({name:'',intro:'',leader:'',leaderIntro:''})
        }
      }
      if(btn==='del'){
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type==='jqg'){
            this.jsonData.jqg.splice(index,1)
          }else if(type==='jsln'){
            this.jsonData.jsln.splice(index,1)
          }else if(type==='gwyg'){
            this.jsonData.gwyg.users.splice(index,1)
          }else if(type==='jtjs'){
            this.jsonData.jtjs.splice(index,1)
          }
        }).catch(() => {
          console.log("已取消")         
        });
      }
    },
    submitForm(){
      this.$confirm('此操作将覆盖原有数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.initFile()
        this.saveData('modelIndex')
      }).catch(() => {
        console.log("已取消")         
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/admin';
</style>